<template lang="pug">
#current_custom_plans
  table.table
    thead
      tr
        th ヒートマップPV
        th ポップアップPV
        th(v-if="!is_new_ui") オーバレイPV
        th(v-if="!is_new_ui") ウィジェットPV
        th 支払期間
        th 月額料金
        th 操作
    tbody
      tr(v-for="custom_plan in $store.state.custom_plan.lists")
        td {{ custom_plan.for_json.heatmap_imp_limit.toLocaleString('ja-JP') }}
        td {{ custom_plan.for_json.pop_up_imp_limit.toLocaleString('ja-JP') }}
        td(v-if="!is_new_ui") {{ custom_plan.for_json.overlay_imp_limit.toLocaleString('ja-JP') }}
        td(v-if="!is_new_ui") {{ custom_plan.for_json.widget_imp_limit.toLocaleString('ja-JP') }}
        td
          template(v-if=" custom_plan.for_json.interval_name == 'month' ") 毎月
          template(v-else-if=" custom_plan.for_json.interval_name == 'three_month' ") 3ヶ月ごと
          template(v-else-if=" custom_plan.for_json.interval_name == 'six_month' ") 半年ごと
          template(v-else-if=" custom_plan.for_json.interval_name == 'year' ") 1年ごと
          template(v-else-if=" custom_plan.for_json.interval_name == 'three_year' ") 3年ごと
        td {{ formatPrice(custom_plan.for_json.interval_name, custom_plan.for_json.amount) }}円
        td
          template(v-if="$store.state.user.current_custom_plan_id == custom_plan.for_json.id")
            button.btn.btn-default.btn-sm.btn-block("disabled"="disabled") 現在のプラン
          template(v-else)
            button.btn.btn-default.btn-sm.btn-block(@click="subscribeModal(custom_plan.for_json)") プラン変更
            button.btn.btn-danger.btn-xs.btn-block(@click="destroyCustomPlan(custom_plan.for_json.id)") 削除
</template>

<script>
import Vue from 'vue';

import StrMixin from '../mixins/str';


export default {
  props: {
    custom_plans: {type: Array, default: []},
    current_custom_plan_id: {type: String, default: ""},
    is_new_ui: { type: Boolean, default: false},
  },
  data(){
    return {
      submitting: false,
    }
  },
  methods: {
    async destroyCustomPlan(id){
      if(this.submitting) return
      this.submitting=true
      if(window.confirm("カスタムプランを削除します。よろしいでしょうか？")){
        let r = await this.$store.dispatch("custom_plan/destroy", id)
        if(r.status == 200){
          this.$store.commit("custom_plan/removeList", id)
          this.$toasted.success('カスタムプランを削除しました。')
        }
      }
      this.submitting=false
    },
    subscribeModal(custom_plan){
      this.$store.commit("user/setCustomPlanToChange", custom_plan)
      this.$store.commit("custom_plan/setCouponCode", "")
      this.$bvModal.show('change-user-custom-plan')
    },
    formatPrice(interval_name, amount){
      if(interval_name == "year"){
        return (amount/12).toLocaleString('ja-JP')
      } else if(interval_name == "three_year"){
        return (amount/36).toLocaleString('ja-JP')
      } else if(interval_name == "six_month"){
        return (amount/6).toLocaleString('ja-JP')
      } else if(interval_name == "three_month"){
        return (amount/3).toLocaleString('ja-JP')
      } else {
        return amount.toLocaleString('ja-JP')
      }
    }
  },
  mixins:[StrMixin],
  watch: {
  },
  computed: {
  },
  async mounted(){
    await Vue.nextTick()
    this.$store.commit("custom_plan/setLists", this.custom_plans)
    if(this.current_custom_plan_id != ""){
      this.$store.commit("user/setCurrentCustomPlanId", this.current_custom_plan_id)
    }
  },
}
</script>
